// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-bottom[data-v-2c0b62cc]{background-color:#f1f1f1}@media only screen and (max-width:1100px) and (min-width:960px){.footer-bottom[data-v-2c0b62cc]{padding-bottom:72px}}.v-application p[data-v-2c0b62cc]{margin-bottom:0}.footer-logo[data-v-2c0b62cc]{height:auto;max-width:100%;padding:0 10px}.footer-info-links li[data-v-2c0b62cc]{display:inline;margin:0 5px}", ""]);
// Exports
module.exports = exports;
